import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import Buttons from '../Components/Buttons'
import { ROUTER } from '../router/constants'
import TimePicker from '../Components/TimePicker'
import { useNavigate } from 'react-router-dom'

const Time = () => {

    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

    const navigate = useNavigate()

    const getTehranTime = () => {
        const tehranTime = new Date().toLocaleTimeString('fa-IR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'Asia/Tehran',
        });
        return tehranTime;
    };

    const [time, setTime] = useState(getTehranTime());


    const handleSaveTime = () => {
        if (time) {
            localStorage.setItem('selectedTime', time);
            navigate(ROUTER.RESERVE_CONFIRM)
        }
    }

    return (
        <div className='container' style={{ padding: isLargeScreen ? '60px 40px' : '30px 20px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant={isLargeScreen ? 'h1' : 'h2'} align="center" color='black' sx={{ fontWeight: isLargeScreen ? 600 : 700, color: 'black', mb: '64px' }}>
                انتخاب ساعت
            </Typography>
            <Box sx={{ mb: "64px" }}>
                <Typography
                    color={theme.palette.info.dark}
                    variant={isLargeScreen ? 'h5' : 'h6'}
                    align="center"
                >
                    ساعت مورد نظر خود را انتخاب نماييد
                </Typography>
                <Grid>
                    <TimePicker setTime={setTime}/>
                </Grid>
            </Box>
            <Buttons backTitle={'بازگشت'} checkTitle={'ثبت'} backLink={ROUTER.RESERVE_ROOM_DATE} checkLink={''} onCheck={handleSaveTime} />
        </div>
    )
}

export default Time
